import { render, staticRenderFns } from "./user_settings.vue?vue&type=template&id=243e880c&scoped=true&"
import script from "./user_settings.vue?vue&type=script&lang=js&"
export * from "./user_settings.vue?vue&type=script&lang=js&"
import style0 from "./user_settings.vue?vue&type=style&index=0&id=243e880c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243e880c",
  null
  
)

export default component.exports